import { Typography, makeStyles } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { useRouteRef } from '@backstage/core-plugin-api';
import { techdocsPlugin } from '@backstage/plugin-techdocs';
import { DEFAULT_NAMESPACE } from '@backstage/catalog-model';

const useStyles = makeStyles(theme => ({
  sublet: {
    color: theme.palette.textSubtle,
  },
  container: {
    padding: theme.spacing(0, 1, 2),
  },
}));

const devPortalEntity = {
  name: 'developer-portal-web',
  kind: 'component',
  namespace: DEFAULT_NAMESPACE,
};

export const Welcome = () => {
  const classes = useStyles();
  const getRouteToReaderPageFor = useRouteRef(techdocsPlugin.routes.docRoot);

  return (
    <div className={classes.container}>
      <Typography variant="h3" gutterBottom>
        Welcome to the Developer Portal!
      </Typography>
      <Typography component="span" className={classes.sublet}>
        Your one stop window into all your development needs for RDC's Paved Path powered by a centralized software
        catalog, with a plugin architecture. <Link to={getRouteToReaderPageFor(devPortalEntity)}>Learn more...</Link>
      </Typography>
    </div>
  );
};
